import { Component, OnInit } from '@angular/core';
import { MainPageService } from '../../main-page.service';
import { PiperingGroupModel } from '../../../models/dictionaries/pipering-group.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';

declare var $: any;


@Component({
  selector: 'app-pipering-groups-grid',
  template: `<!-- Create Modal -->
<div class="modal" id="addPiperingGroupModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedPiperingGroup.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Code:</span>
                                    <input type="text" [(ngModel)]="editedPiperingGroup.code" formControlName="code">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Is cold:</span>
                                    <input type="checkbox" [(ngModel)]="editedPiperingGroup.isCold" formControlName="isCold">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="saveNewPiperingGroup()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedPiperingGroup.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Code:</span>
                                    <input type="text" [(ngModel)]="editedPiperingGroup.code" formControlName="code">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Is cold:</span>
                                    <input type="checkbox" [(ngModel)]="editedPiperingGroup.isCold" formControlName="isCold">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="editPiperingGroup()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Pipe-ring Group?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deletePiperingGroup(editedPiperingGroup)">Delete</button>
            </div>
        </div>
    </div>
</div>


<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addPiperingGroupModal" (click)="prepareCreate()">Create</button>

<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let piperingGroup of piperingGroupsGridData, let row_no = index">
        <td>{{piperingGroup.id}}</td>
        <td>{{piperingGroup.name}}</td>
        <td>{{piperingGroup.code}}</td>
        <td>{{piperingGroup.isCold}}</td>
        <td class="columnWithIcons">
            <button type="button" class="btn editBtn" data-toggle="modal" data-target="#editModal" (click)="setChoosenElement(piperingGroup, row_no)">
                <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(piperingGroup, row_no)">
                <i class="fa fa-trash"></i>
            </button>
        </td>
    </tr>
</table>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class PiperingGroupsGridComponent implements OnInit {
  public isPiperingGroupsHidden = true;
  public piperingGroupsGridData: PiperingGroupModel[];
  public editedPiperingGroup = new PiperingGroupModel();
  public rowNumber: number;
  public headers: string[] = ['Id', 'Name', 'Code', 'Is cold', ''];
  public formGroup: FormGroup;

  constructor(private mainPageService: MainPageService) {}

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deletePiperingGroupSubject.subscribe( (value) => {
      this.piperingGroupsGridData = this.piperingGroupsGridData.filter(x => x._id !== value);
    });
    this.createForm();
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllPiperingGroups().subscribe((response) => {
      this.piperingGroupsGridData = response.sort(function (a, b) {
        return (a.id < b.id) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
        $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isPiperingGroupsHidden = !this.isPiperingGroupsHidden;
  }

  saveNewPiperingGroup() {
    this.mainPageService.addNewPiperingGroupIntoDb(JSON.stringify(this.editedPiperingGroup)).subscribe((response) => {
      this.editedPiperingGroup._id = response._id;
      this.editedPiperingGroup.id = response.id;
      this.piperingGroupsGridData.push(this.editedPiperingGroup);
      this.editedPiperingGroup = new PiperingGroupModel();
      this.createForm();
    });
  }

  setChoosenElement(element, row) {
    this.editedPiperingGroup = {
      ...element,
    };
    this.rowNumber = row;
    this.createForm();
  }

  editPiperingGroup() {
    console.log(this.piperingGroupsGridData[this.rowNumber]);
    Object.assign(this.piperingGroupsGridData[this.rowNumber], this.editedPiperingGroup);
    this.mainPageService.updatePiperingGroupInDb(JSON.stringify(this.editedPiperingGroup)).subscribe(() => { });
  }

  deletePiperingGroup(element) {
    this.mainPageService.removePiperingGroup(element._id).subscribe(() => { }, () => { });
    this.mainPageService.deletePiperingGroupSubject.next(element._id);
  }

  public prepareCreate() {
    this.editedPiperingGroup = new PiperingGroupModel();
    this.createForm();
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.editedPiperingGroup.name, Validators.required),
      code: new FormControl(this.editedPiperingGroup.code),
      isCold: new FormControl(this.editedPiperingGroup.isCold)
    });
  }
}
